// scroll-effect in-view.js
(function () {

  // 変数
  var $elm = document.getElementsByClassName('js-scroll');
  var $fixed = document.getElementById('js-fixed-btn');
  var $fixedTrigger = document.getElementById('js-fixed-trigger');

  // 固定ボタン処理
  if ($fixed && $fixedTrigger) {
    // inView.offset({
    //   bottom: 50
    // });
    inView('#js-fixed-trigger').on('enter', function($target) {
      // $target.classList.add('effect-is-active');
      $fixed.classList.add('is-show');
    });
    inView('#js-fixed-trigger').on('exit', function($target) {
      // $target.classList.add('effect-is-active');
      if ($fixed.classList.contains('is-show')) {
        $fixed.classList.remove('is-show');
      }
    });
    inView('#js-footer').on('enter', function($target) {
      // $target.classList.add('effect-is-active');
      if ($fixed.classList.contains('is-show')) {
        $fixed.classList.remove('is-show');
      }
    });
    inView('#js-footer').on('exit', function($target) {
      // $target.classList.add('effect-is-active');
      if (!$fixed.classList.contains('is-show')) {
        $fixed.classList.add('is-show');
      }
    });
  } else {
    // console.log('hoge');
  }

  // 普通の処理
  if ($elm.length) {
    inView.offset({
      bottom: 50
    });
    inView('.js-scroll').on('enter', function($target) {
      // $target.classList.add('effect-is-active');
      $target.classList.add('effect-is-active');
    });
  } else {
    // console.log('hoge');
  }

}());
